const state = {
  data_loaded: false,
  hoveredDate: null
};

const getters = {
  data_is_loading(state) {
    return !state.data_loaded;
  }
};

const mutations = {
  DATA_LOADED(state, value) {
    state.data_loaded = value;
  },
  SET_HOVERED_DATE(state, value) {
    state.hoveredDate = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations
};
